<script setup>
// eslint-disable-next-line object-curly-newline
import {
  ref,
  reactive,
  defineProps,
  inject,
  defineEmits,
  useSlots,
  useAttrs,
  defineExpose,
  onMounted,
  computed,
  watch,
  watchEffect,
} from 'vue';
import InnerSetup from './inner-setup.vue';
import { useIns } from '../../utils/v2_helper/common';

const emit = defineEmits(['change', 'delete']);
const app = useIns();
const props = defineProps({
  name: {
    type: String,
    default: 'ajckson',
  },
});
const count = reactive({
  count: 0,
});
const add = () => {
  count.count += 1;
  emit('change', count.count);
};
// ===$listeners & $attrs
console.log('lst & atr: ', app.$listeners, app.$attrs);
const pCount = '';

// slots attrs
const slots = useSlots();
const attrs = useAttrs();
console.log(slots, attrs);

// const name = ref('notfound');
onMounted(() => {
  // setTimeout(() => {
  //   name.value = 'jackson'
  // }, 1000)
});
const innerRef = ref(null);
// define expose
defineExpose({
  add,
  happyName: computed(() => innerRef.value?.happyName),
});

const vo = inject('vo');

watch(vo, (v) => {
  console.log(vo);
});
</script>

<template>
  <div style="background: red">
    <h2>VO: {{ JSON.stringify(vo) }}</h2>
    Setup Component
    <button @click="add">add {{ count.count }}</button>
    <h5>
      inject pCount: {{ pCount }}
      <button @click="pCount.innerValue++">changePcount</button>
    </h5>
    <slot name="dddddd" />
    <InnerSetup ref="innerRef" />
  </div>
</template>

<style></style>
